import * as React from "react";
import { useFormContext } from "react-hook-form";
import { NGLabelText } from "../../../newcomponents/text/labelText";
import { FormDryRunAlert } from "./formDryRunAlert";
import { Workload } from "../../../schema/types/workload/workload";
import { linksOf } from "../../../services/cpln";
import clsx from "clsx";
import { ngParseLink } from "../../../utils/linkParser/linkParser";
import { FormNGKindSelect } from "./components/FormNGKindSelect";
import { DomainInput } from "./types/input";

interface Props {}
export const CreateNGAdvancedWorkloadSubdomain: React.FC<Props> = ({}) => {
  const { control, watch, setValue } = useFormContext<DomainInput>();

  const dryRunNameOnly = watch("dryRun.nameOnly.value") || {};
  const routingMode = watch("advanced.spec.routingMode") || "";

  const workloadName = watch("advanced.spec.workload.name") || "";
  const gvcName = watch("gvc.name") || "";

  if (dryRunNameOnly.status !== 200) {
    return null;
  }

  if (routingMode !== "workloadSubdomain") {
    return null;
  }

  return (
    <div className="mb-8">
      <div className="flex items-center">
        <NGLabelText className="cursor-default">Workload Selection</NGLabelText>
        <span className="color-danger">*</span>
      </div>
      <FormNGKindSelect<Workload>
        name="advanced.spec.workload.link"
        control={control}
        rules={{ required: "Workload is required" }}
        filterOptions={(item: Workload) => item.spec.type === "stateful"}
        onChangeExtra={(relativeLink, item) => {
          const gvcLink = linksOf(item).gvc!;
          const { name: gvcName } = ngParseLink(gvcLink, { useInputCtx: true });
          setValue("advanced.spec.workload.name", item.name);
          setValue("advanced.spec.workload.link", relativeLink);
          setValue("gvc.name", gvcName);
          setValue("gvc.link", gvcLink);
        }}
        kind="workload"
        getOptionLabel={(option) => option.name}
        optionValueAs={`relative`}
        style={{ width: 600 }}
        renderOption={({
          option,
          getOptionLabel,
          getOptionValue,
          isHovered,
          isDisabled,
          isLabel,
          isSelected,
          props,
        }) => {
          const gvcLink = linksOf(option).gvc!;
          const { name: _gvcName } = ngParseLink(gvcLink, { useInputCtx: true });

          return (
            <li
              key={getOptionValue(option)}
              {...props}
              className={clsx(`flex items-center justify-between color-default`, {
                "option-hover": isHovered,
                "option-selected": isSelected,
                "option-label": isLabel,
                "option-disabled": isDisabled,
                "cursor-not-allowed": isLabel || isDisabled,
              })}
            >
              <span className="truncate">{getOptionLabel(option)}</span>
              <div className="flex items-center gap-1 text-sm">
                <NGLabelText className="text-sm">GVC</NGLabelText>
                <span>{_gvcName}</span>
              </div>
            </li>
          );
        }}
      />
      <FormDryRunAlert path={"spec.workloadLink"} />
    </div>
  );
};
